<template>
	<div id="app">
		<div class="top1"></div>
		<div class="top2"></div>
		<div class="top3"></div>
	</div>
</template>

<script>
	export default {
		name: 'app',
		components: {}
	}
</script>

<style>
	body,
	html,
	div {
		margin: 0;
		padding: 0;
		
	}
	body {
		

	}
	#app {
		width: 100%;
		height: 100%;
		background: url('./assets/38.png') no-repeat;
		background-size: 100% 100%;
		
	}
	.top1 {
		margin: 0 auto;
		width: 1580px;
		height: 100px;
		background: url('./assets/top.png') no-repeat;
		background-size: 100% 100%;
	}
	.top2 {
		margin: 0 auto;
		width: 1580px;
		height: 2049px;
		background: url('./assets/bg.png') no-repeat;
		background-size: 100% 100%;
	}
	.top3 {
		margin: 0 auto;
		width: 1580px;
		height: 300px;
		background: url('./assets/down4.png') no-repeat;
		background-size: 100% 100%;
	}
</style>